<template>
  <div class="body warp">
    <div class="content">
      <div class="buju">
        <div class="tuijian" v-if="noImg">
          <div class="pictBox">
            <img class="pict" src="../../assets/images/zhutuikuan.png" alt="" />
          </div>

          <div v-if="noImg" class="lunbo">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide
                class="swiper-slide"
                v-for="item in imgData"
                :key="item"
              >
                <div class="swiper-content">
                  <img
                    :src="item.image"
                    alt=""
                    @click="toProductDetail(item)"
                    style="width: 155px; height: 155px"
                  />
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <i class="el-icon-arrow-right"></i>
              </div>
            </swiper>
          </div>
        </div>
        <div class="box2 flex-col">
          <div class="bd3 flex-row">
            <img
              class="label3"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng13a746e8307d734f4df8ab7961335667735c3aa0dca9036d8bdd802c1b29c1ae"
            />
            <span class="info5">最新商品</span>
            <img
              class="label4"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng6e22c3954334c26456733d5ad5a4c16913ccac1713429f9adfe43e05929658be"
            />
          </div>
          <div class="productList">
            <ProductList :productList="productList"></ProductList>
            <div style="display: block;padding-bottom: 20px;text-align: center;">
                  <el-pagination
                    v-if="productList.length > 0"
                    :current-page="page"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="total"
                  >
                  </el-pagination>
                </div>
          </div>
        </div>
      </div>
      <!-- <div class="main9 flex-col">
        <div class="line">
          <span class="text">看了又看</span>
        </div> -->
      <!-- <div class="look"> -->
      <!-- <div class="looklong">
          <ul v-infinite-scroll="load" style="overflow: auto; width: 317px">
              <li>
                <ProductList
                  style="width: 260px;height:1525px"
                  :productList="productList"
                ></ProductList>
              </li>
            </ul>
        </div> -->
      <!-- <el-carousel
            type="card"
            :autoplay="false"
            direction="vertical"
            style="width:300px;height:1525px;padding-left:100px ;padding-top:50px">
            <el-carousel-item v-for="(item, index) in item" :key="index">
              <span>
                <img :src="item.image" alt="" />
              </span>
            </el-carousel-item>
          </el-carousel> -->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import ProductList from "../base_b2c/productList";
import api from "@/api_b2c";
import { listSearchMixin } from "../../config/mixin";
import { mapGetters, mapMutations } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  mixins: [listSearchMixin],
  components: {
    swiper,
    swiperSlide,
    ProductList,
  },
  data() {
    return {
      // 轮播图
      swiperOption: {
        slidesPerView: 5, // 每页展示几条数据
        slidesPerGroup: 1, // 每屏滚动几条数据
        autoplay: false, // 是否自动播放
        // loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "",
        },
        observer: true,
        observeParents: true,
      },
      banner: "",
      activeName: this.$route.query.classify || "all",
      index: "1",
      classifyTitle: "",
      shopClassifyList: [],
      shopId: null,
      productList: [],
      shopName: null,
      shopLogo: null,
      total: 0,
      pageSize:20,
      type: "",
      volume: "",
      page: 1,
      noProduct: false,
      isIndex: true,
      isDossier: false,
      isContact: false,
      isShopClassifyList: false,
      item: {
        image: "",
      },
      maxMoney: "",
      minMoney: "",
      searchFrom: {
        search: "",
      },
      loading: false,
      network: false,
      keyword: "",
      status: "",
      ifNew: "",
      imgData: [],
      noImg: true,
    };
  },
  computed: {
    ...mapGetters(["collectData"]),
    // ...mapMutations({
    //   setSearchObj: "SET_SEARCHOBJ",
    // }),
  },
  mounted() {
    this.shopId = parseInt(this.$route.query.shopId);
    this.getShopProducts();
    this.getNew();
  },
  methods: {
    // 分页器跳转
    handleCurrentChange(val) {
      this.status = ""
      this.page = val;
      sessionStorage.setItem("curentPage4", this.page);
      this.getShopProducts();
    },
    //商家推荐点击进入商品详情
    toProductDetail(item) {
      let data = {
        productId: item.productId,
        skuId: item.skuId,
        shopId: item.shopId,
      };
      this.$router.push({
        path: "/shop_mall/productDetail",
        query: {
          proData: JSON.stringify(data),
        },
      });
    },
    getNew(){
      let self = this;
      self.status = 1
      let _url =
        api.getShopProducts +
        `?shopId=${self.shopId}&ifNew=${self.ifNew}&page=${self.page}&pageSize=20&type=${self.type}&volume=${self.volume}`;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      this.imgData = [];
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          //获取推荐商品列表图片
          // this.productList = res.data.page.list;
          let imgUrl = res.data.page.list;
          this.total = res.data.page.total;
          console.log(imgUrl);
          for (let i = 0; i < imgUrl.length; i++) {
            if (imgUrl[i].productStatus == 1) {
              this.imgData.push(imgUrl[i]);
            }
          }
          if (this.imgData.length == 0) {
            this.noImg = false;
          } else {
            this.noImg = true;
          }
          // if (res.data.page.list.length < 1) {
          //   this.noProduct = true;
          // } else {
          //   this.noProduct = false;
          // }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    getShopProducts() {
      let self = this;
      if (sessionStorage.getItem("curentPage4") ) {
        self.page = sessionStorage.getItem("curentPage4");
      }
      let _url =
        api.getShopProducts +
        `?shopId=${self.shopId}&ifNew=${self.ifNew}&status=${self.status}&page=${self.page}&pageSize=20&type=${self.type}&volume=${self.volume}`;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      // this.imgData = [];
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          //获取推荐商品列表图片
          this.productList = res.data.page.list;
          // let imgUrl = res.data.page.list;
          this.total = res.data.page.total;
          console.log(imgUrl);
          // for (let i = 0; i < imgUrl.length; i++) {
          //   if (imgUrl[i].productStatus == 1) {
          //     this.imgData.push(imgUrl[i]);
          //   }
          // }
          // if (this.imgData.length == 0) {
          //   this.noImg = false;
          // } else {
          //   this.noImg = true;
          // }
          if (res.data.page.list.length < 1) {
            this.noProduct = true;
          } else {
            this.noProduct = false;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    //推荐商品
    tuijianProduct() {
      this.status = 1;
      this.ifNew = "";
      this.getShopProducts();
    },
  },
};
</script>
<style lang="scss" scoped>
.body {
  width: 100%;
  background: #f5f5f5;
  // padding: 0 85px;
}
.content {
  width: 100%;
  // margin-top: 20px;
  // display: flex;
  // justify-content: space-between;
}
.swiper-content {
  padding: 0 50px 50px 50px;
}
.swiper-container {
  height: 200px;
  line-height: 200px;
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 30px; /* 设置按钮大小 */
  img {
    width: 100%;
    margin: auto 0;
  }
}
.swiper-button-prev {
  width: 35px;
  height: 35px;
  color: red;
  font-size: 28px;
  text-align: center;
  background: #f77b0b;
  opacity: 0.2;
  margin-top: 2px;
  line-height: 38px;
  border-radius: 50%;
}
.swiper-button-next {
  width: 35px;
  height: 35px;
  color: red;
  font-size: 28px;
  text-align: center;
  background: #f77b0b;
  opacity: 0.2;
  margin-top: 2px;
  line-height: 38px;
  border-radius: 50%;
}
.lunbo {
  // width: 800px;
  margin-left: 200px;
  margin-top: 20px;
}
.swiper {
  width: 90%;
}

.tuijian {
  position: relative;
  width: 100%;
  height: 234px;
  margin-top: 40px;
  background: #fff;
  .pictBox {
    position: absolute;
    left: 0;
    right: 0;

    width: 865px;
    height: 234px;
    background: linear-gradient(
      279deg,
      rgba(255, 255, 255, 0) 0%,
      #ffd2a9 100%
    );
  }
  .pict {
    height: 100%;
  }
  // .buju {
  //   background: #fff;
  // }
}

.line {
  height: 0;
  width: 317px;
  border-top: 1px solid #dedada;
  text-align: center;
  margin-top: 20px;
  padding-top: 3px;
}
.text {
  position: relative;
  top: -14px;
  background-color: #fff;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
}
.main9 {
  // float: right;
  background: white;
  margin-left: 30px;
  width: 300px;
}
.box2 {
  background-color: rgba(255, 255, 255, 1);
  // margin-top: 20px;
  width: 100%;
}

.bd3 {
  width: 220px;
  height: 35px;
  justify-content: space-between;
  margin: 20px auto;
  padding: 30px 0;
}
.label3 {
  // z-index: 20;
  width: 16px;
  margin-top: -5px;
}
.info5 {
  // width: 104px;
  height: 45px;
  display: inline-block;
  /* display: block; */
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 26px;
  font-weight: bold;

  // line-height: 80px;
  text-align: right;
  margin: 5px 20px;
}
.label4 {
  // z-index: 23;
  width: 16px;
  margin-top: -5px;
}
.productList {
  // width: 257px;
}
>>> .el-carousel__container {
  position: relative;
  height: 85% !important;
}
.el-carousel__item {
  img {
    width: 155px;
    height: 155px;
  }
}
>>> .el-carousel__indicators {
  display: none;
}
>>> .el-carousel__item {
  width: 155px;
  height: 155px;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.zhutui {
  width: 155px;
  height: 155px;
}
.righrlunbo {
  width: 257px;
  height: 257px;
}
.look {
  width: 300px;
  height: 1525px;
}
.looklong {
  height: 1525px;
  padding-top: 40px;
}
>>> button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
  background: #f77b0b;
}
>>> *[data-v-ea745822],
*[data-v-ea745822]:before,
*[data-v-ea745822]:after {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
}
element.style {
  overflow: auto;
  width: 317px;
  margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/canvasShow/shopHome_b2c.vue